import {useMutation} from "@apollo/client";

import {Alert} from "@/components/alert/Alert.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_ACCOUNTUSER_MAKE_PRIMARY, GQL_ACCOUNTUSERS_QUERY, GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface UserActionMakePrimary {
  user: AccountUser;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const UserActionMakePrimary = ({user, show, setShow}: UserActionMakePrimary) => {
  const [makePrimary, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(GQL_ACCOUNTUSER_MAKE_PRIMARY, {
    refetchQueries: [GQL_ACCOUNTUSERS_QUERY, GQL_USER_CONTEXT],
  });

  const handleSubmit = async () => {
    const response = await makePrimary({
      variables: {
        id: user.id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  return (
    <ActionDialog
      show={show}
      loading={loading}
      title={serverErrors?.length > 0 ? "Unable to Transfer Ownership" : "Make an Owner"}
      onConfirm={handleSubmit}
      onCancel={() => {
        setShow(false);
        reset();
      }}
      confirmBtnText="Yes"
      hasConfirmButton={true}
      hasCancelButton={true}
    >
      <Alert size="small" show>
        <p className="text-center m-0">Are you sure you want to transfer ownership of this account to {user.email}?</p>
      </Alert>
    </ActionDialog>
  );
};
